import React from 'react';
import { string, bool, oneOf } from 'prop-types';
import { Space } from 'antd';

const FaIcon = ({
  icon,
  modifier = 'fa',
  text = '',
  right = false,
  className = '',
  size = null,
}) => {
  const classNames = [
    `fa-${icon}`,
    modifier,
    className,
    size && `fa-${size}`,
  ].filter(Boolean).join(' ');

  return (
    <Space style={{ flexDirection: right ? 'row-reverse' : 'row' }}>
      <i className={classNames} />
      {text}
    </Space>
  );
};

FaIcon.propTypes = {
  icon: string.isRequired,
  text: string,
  className: string,
  right: bool,
  size: string,
  modifier: oneOf(['fa', 'fas', 'far', 'fad', 'fab', 'fal']),
};

export default FaIcon;
